import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import {
  Row,
  Col
} from 'react-bootstrap'
import * as styles from './Submarine.module.css'

const COB = () => {
  const data = useStaticQuery(graphql`
  {
   Cob: file(relativePath: { eq: "Jesse-H-Davis.jpg" }) {
    childImageSharp {
     fluid(maxWidth: 330, quality: 80) {
      ...GatsbyImageSharpFluid
     }
    }
   }
  }
 `)

 return (
  <>
    <Row style={{
      backgroundColor: '#426690',
      borderRadius: '5px',
      padding: '2rem',
    }}>
      <Col sm={9} className={styles.leadershipReverse}>
      <h2>Chief of the Boat</h2>
      <h3>Chief Jesse H. Davis</h3>
      <hr style={{borderColor: 'rgba(255, 255, 255, 0.25)'}}/>
      
      <p>Senior Chief Jesse Davis, a native of Woodstock, Vermont, entered the Navy on October 9, 2013. Following Recruit Training in Great Lakes, Illinois, he completed the Basic Enlisted Submarine School and Torpedoman’s Mate "A" School in Groton, Connecticut.</p>
      <p>In the fall of 2018, he reported to USS MINNESOTA (SSN 783). During this tour, the ship completed a European theater deployment and two Submarine Command Courses. While assigned to the MINNESOTA, the command was awarded the Battenberg Cup, the Submarine Squadron 4 Battle "E," and an "Excellent" rating on its Combat Readiness Evaluation. He was advanced to Chief Petty Officer during this assignment.</p>
      <p>In March 2021, he reported to USS HELENA (SSN 725), serving as the Torpedo Division Leading Chief Petty Officer and Assistant Chief of the Boat.</p>
      <p>During his two-year tour, he was part of the leadership team during the ship’s undocking and subsequent Sea Trials.</p>

<p>From June 2023 to February 2026, Senior Chief Davis served as the 15th Company Senior Enlisted Leader at the U.S. Naval Academy. He reported to PCU IDAHO (SSN 799) in March 2026</p>

      </Col>
      <Col md={3}>
        <Img fluid={data.Cob.childImageSharp.fluid} alt="Chief Jesse H. Davis" className="rounded" />
      </Col>
    </Row>
  </>
 )
}

export default COB